module.exports = __webpack_public_path__ + "media/images/cheers_sent_success_3-cdf3ce4dc8c35825a1b7e2a4c5b3a1fd.gif";